import { defineComponent as n, openBlock as s, createElementBlock as t, createElementVNode as e, createStaticVNode as c } from "vue";
const i = {
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.1",
  viewBox: "0 0 530 530"
}, a = /* @__PURE__ */ e("path", {
  d: "M452.0675354003906,78.06758117675781 a263,263 0 0 0 -374,0 a263,263 0 0 0 0,374 a263,263 0 0 0 374,0 a263,263 0 0 0 0,-374 zm-21,353 a233,233 0 0 1 -332,0 a233,233 0 0 1 0,-332 a233,233 0 0 1 332,0 a233,233 0 0 1 0,332 z"
}, null, -1), d = {
  ref: "core",
  class: "core"
}, r = /* @__PURE__ */ e("path", {
  d: "M496.5675354003906,263.5675354003906 l-135,-13 c-3,-19 -11,-37 -23,-51 l35,-43 l-43,36 a97,97 0 0 0 -53,-25 l-13,-133 l-13,133 c-20,2 -39,12 -53,25 l-44,-36 l36,44 a98,98 0 0 0 -22,50 l-135,13 l135,13 c2,21 12,40 26,54 l-36,44 l43,-36 c14,11 31,19 50,22 l13,135 l13,-135 c19,-3 36,-11 50,-22 l43,36 l-35,-44 c14,-14 23,-33 26,-54 l135,-13 zm-232,88 a87,87 0 1 1 0,-175 a87,87 0 0 1 0,175 z"
}, null, -1), p = [r], v = {
  ref: "needle",
  class: "needle"
}, m = /* @__PURE__ */ e("path", {
  d: "M300.5675354003906,301.0675354003906 c-8,8 -19,11 -30,8 l124,88 h2 v-3 l-88,-124 l1,8 c1,8 -2,17 -9,23 zm-3,-36 c0,-6 -2,-12 -6,-18 l-15,-13 l-141,-101 h-2 v3 l101,141 l2,2 l2,3 l9,9 l4,3 c12,6 27,5 37,-5 c6,-7 9,-15 9,-24 zm-28,5 a9,9 0 1 1 -13,-13 a9,9 0 0 1 13,13 z"
}, null, -1), h = [m], z = /* @__PURE__ */ n({
  name: "CompassSpinner",
  __name: "CompassSpinner",
  setup(l) {
    return (o, _) => (s(), t("svg", i, [a, e("g", d, p, 512), e("g", v, h, 512)]));
  }
});
const u = {
  class: "inlineSpinner"
}, S = /* @__PURE__ */ c('<div class="dot"></div><div class="dot"></div><div class="dot"></div><div class="dot"></div><div class="dot"></div>', 5), g = [S], f = /* @__PURE__ */ n({
  name: "InlineSpinner",
  __name: "InlineSpinner",
  setup(l) {
    return (o, _) => (s(), t("div", u, g));
  }
});
export {
  z as CompassSpinner,
  f as InlineSpinner
};
